/* eslint-disable semi,semi-style */
import { env } from '@/util/env';
// http://view.didistatic.com/static/dcms/548313280_medium_1.png

let prefix = 'https://static';
let basePath;
if (env === 'pre') {
  prefix = 'https://static-pre';
}
if (env === 'dev' || env === 'test') {
  basePath = 'https://open-epower.intra.xiaojukeji.com';
}
export default [
  {
    title: '运维监控',
    hidden: true,
    node: 'app',
    path: '/devops',
    exact: false,
    res: basePath ? basePath + '/devops' : prefix + '.am.xiaojukeji.com/epower/epower-devops/view/index.html',
  },
  {
    title: '服务管理',
    hidden: true,
    node: 'app',
    path: '/service',
    exact: false,
    res: prefix + '.am.xiaojukeji.com/epower/epower-open-service/view/index.html',
  },
  {
    title: '桩企接入',
    node: 'appsub',
    path: '/direct',
    exact: false,
    desc: '查看桩企接入开发文档，操作桩设备接入联调测试',
    res: basePath ? basePath + '/direct' : prefix + '.am.xiaojukeji.com/epower/epower-open-direct/view/index.html',
  },
  {
    title: '互通互联接入',
    node: 'root',
    path: '/join',
    exact: false,
    desc: '查看互联互通接入开发文档，自助操作加盟运营商接入服务',
    res: prefix + '.am.xiaojukeji.com/epower/epower-open-join/view/index.html',
    /**
     * 老接入方式已废弃
     * prd: http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=943053843
     */
    isAbandon: true,
  },
  {
    title: '反向互通互联接入',
    node: 'appsub',
    path: '/comming',
    exact: true,
    desc: '查看反向互联互通接入开发文档，接入滴滴充电充电桩信息和充电服务',
  },
  // {
  //   title: "停车场接入",
  //   node: "root",
  //   path: "/parking",
  //   exact: false,
  //   desc: "查看停车场开发文档，自助接入小桔停车减免平台",
  //   res:
  //     prefix + ".am.xiaojukeji.com/epower/epower-open-parking/view/index.html",
  //   imgIndex: 5,
  // },
  {
    title: 'H5自助接入',
    node: 'app',
    path: '/h5',
    exact: false,
    desc: '查看滴滴充电H5接入文档，自助接入充电H5页面',
    res: prefix + '.am.xiaojukeji.com/epower/h5-abutment-docs/view/index.html',
    // https://view.didistatic.com/static/dcms/548313280_medium_7.png
    imgIndex: 7,
  },
  {
    title: '刷卡接入',
    node: 'appsub',
    path: '/comming',
    exact: true,
    desc: '查看刷卡开发文档，自助操作刷卡流程联调测试',
    imgIndex: 4,
  },
];
